import { Attributes, NeoModel, Validation, ValueObject } from '@singularsystems/neo-core';
import { PreferredCommunicationMethod } from '../Enums/PreferredCommunicationMethod';

@NeoModel
export default class UpdateCommunicationPreferenceCommand extends ValueObject {

    /** The participant's preferred communication method. Null clears the override and uses the org default. */
    @Attributes.Nullable()
    public preferredCommunicationMethod: PreferredCommunicationMethod | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Update Communication Preference Command";
    }
}
